import { useEffect, useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { api, mediaUrl } from "@/lib/api";
import { GrowthListBlock } from "@/components/EmailCapture";

export default function Weekly() {
  const [m, setM] = useState(undefined);
  useEffect(() => {
    api.get("/weekly/latest").then((r) => setM(r.data)).catch(() => setM(null));
  }, []);
  if (m === undefined) return <div className="min-h-[60vh]" />;
  return (
    <div className="container-bt py-14 sm:py-20" data-testid="weekly-page">
      <article className="mx-auto max-w-2xl">
        <p className="eyebrow mb-4">{m ? (m.kind === "affirmation" ? "This month's affirmation" : `This week · ${m.theme}`) : "Weekly message"}</p>
        <h1 className="text-4xl leading-tight sm:text-5xl" data-testid="weekly-subject">{m ? m.subject : "Your first message is coming soon."}</h1>
        {m?.audio_url && (
          <div className="mt-8 rounded-[24px] bg-bt-sage p-5" data-testid="weekly-audio">
            <p className="eyebrow mb-3">Listen together</p>
            <audio src={mediaUrl(m.audio_url)} controls className="w-full" />
          </div>
        )}
        {m && (
          <div className="mt-8 space-y-5 text-lg leading-relaxed">
            {m.body.split("\n\n").map((p, i) => <p key={i} className="whitespace-pre-line">{p}</p>)}
          </div>
        )}
        {m?.cta_url && (
          <a href={m.cta_url} target="_blank" rel="noopener noreferrer" className="btn-primary mt-10" data-testid="weekly-cta">{m.cta_label} <ArrowUpRight size={18} /></a>
        )}
      </article>
      <div className="mx-auto mt-20 max-w-5xl"><GrowthListBlock source="weekly" /></div>
    </div>
  );
}
